import { useQuery } from '@tanstack/react-query';
import { axios } from './axios';
import { ExtractFnReturnType, QueryConfig } from "./queryConfig";


interface IBarrierConfigAuditId {
  projectId: string | undefined
  assetId: string | undefined
  category?: string
}

type ResponseData = {
  audit_id: string
  asset_name: string | undefined
  project_name: string | undefined
}

export const getBarrierConfigAuditId = ({ projectId, assetId , category}: IBarrierConfigAuditId): Promise<ResponseData> => {
  return axios.get(`/oe/config/project/${projectId}/asset/${assetId}/configurable-audit`, {
    params: {
      category,
    },
  }).then(res => res.data as ResponseData)
}

type QueryFnType = typeof getBarrierConfigAuditId
interface IuseBarrierConfigAssetData extends IBarrierConfigAuditId {
  config: QueryConfig<QueryFnType>
}

export const useBarrierConfigAuditId = ({ projectId, assetId, category, config }: IuseBarrierConfigAssetData) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['barrierAuditId', projectId, assetId, category],
    queryFn: () => getBarrierConfigAuditId({ projectId, assetId, category }),
    enabled: !!assetId,
    ...config

  })
}